import { commonEncrypt } from "../config";
import CryptoJS from "crypto-js";
// const crypto = require("crypto");

export const CheckCaptchValid = (msg: string) => {
  const secret_key = commonEncrypt.secret_key;
  const iv = commonEncrypt.iv;
  try {
    const message: any = msg || "";
    const decrypt = CryptoJS.AES.decrypt(message, secret_key, { iv: iv });
    const originalText = decrypt.toString(CryptoJS.enc.Utf8);
    if (originalText) {
      return originalText;
    }
  } catch (error) {}
};
